import { apiClient } from './apiClient';
import { getApiData, getProp } from '../utils/apiResponse';

export interface DirectoryRole {
  id: string;
  displayName: string;
  description: string;
  roleTemplateId: string;
}

export interface DirectoryRoleMember {
  id: string;
  displayName: string;
  userPrincipalName: string;
  '@odata.type': string;
}

class RoleService {
  private getCollection<T>(response: any, operation: string): T[] {
    let data: any;
    try {
      data = getApiData<any>(response, operation);
    } catch {
      return [];
    }

    if (Array.isArray(data)) {
      return data as T[];
    }

    const value = getProp(data, 'value');
    if (value == null) {
      return [];
    }

    if (Array.isArray(value)) {
      return value as T[];
    }

    return [];
  }

  async getDirectoryRoles(): Promise<any> {
    const response = await apiClient.get<any>('/directory-roles');
    return response;
  }

  async getDirectoryRoleMembers(roleId: string): Promise<any> {
    const response = await apiClient.get<any>(`/directory-roles/${roleId}/members`);
    return response;
  }

  async getGlobalAdministrators(): Promise<any> {
    try {
      // First get all roles
      const rolesResponse = await this.getDirectoryRoles();
      const roles = this.getCollection<any>(rolesResponse, 'loading directory roles');

      // Find Global Administrator role
      const globalAdminRole = roles.find(
        (role: any) => (role.displayName || role.DisplayName) === 'Global Administrator'
      );

      if (!globalAdminRole) {
        return { data: { value: [] } };
      }

      // Get members of Global Administrator role
      const roleId = globalAdminRole.id || globalAdminRole.Id;
      if (!roleId) {
        return { data: { value: [] } };
      }

      const membersResponse = await this.getDirectoryRoleMembers(roleId);
      const members = this.getCollection<any>(
        membersResponse,
        'loading global administrator members'
      );
      return { data: { value: members } };
    } catch {
      return { data: { value: [] } };
    }
  }
}

export const roleService = new RoleService();
